import ReactGA from "react-ga4";
import { Backend } from "./url";

/**
 * Records a "Go to Membrane Builder" outbound click.
 *
 * Sent both to GA4 (no-op when REACT_APP_GA_MEASUREMENT_ID is unset) and to a
 * 1st-party backend endpoint, which is not lost to ad blockers or GA4 data
 * thresholding. The button opens a new tab, so the page stays alive and the
 * backend write is fire-and-forget — failures are ignored and never block
 * navigation.
 */
export function trackMembraneBuilderClick(lnpId: string) {
  ReactGA.event("membrane_builder_click", {
    lnp_id: lnpId,
    source: "clipboard_modal",
  });

  fetch(`${Backend}/search/outbound/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: "membrane_builder",
      lnp_id: lnpId,
      source: "clipboard_modal",
    }),
    keepalive: true,
  }).catch(() => {});
}
